import { mergeMap } from '@/utils/tool'
import type { ComposerTranslation } from 'vue-i18n'

/**
 * 风险类型 id → vue-i18n 键（`safeProtectionModule.*`）。
 * 展示：`t(RISK_TYPE_I18N_KEYS[id])`；需与 remover-log-tab / risk-view-table 等页的 riskTypeLabelI18n 保持一致。
 */
export const RISK_TYPE_I18N_KEYS: Record<number, string> = {
  1: 'safeProtectionModule.riskCatWebSettings',
  2: 'safeProtectionModule.riskCatSystemGeneral',
  3: 'safeProtectionModule.riskCatSystemSecurity',
  4: 'safeProtectionModule.riskCatBrowser',
  5: 'safeProtectionModule.riskCatMobile',
  6: 'safeProtectionModule.riskCatExtDir',
  10000: 'safeProtectionModule.riskCatCustomDir',
  20000: 'safeProtectionModule.fileSecurity',
  1000000: 'safeProtectionModule.activeDefense',
}

/** 当前语言下的风险类型文案（用于表格单元格等） */
function riskTypeLabels (t: ComposerTranslation): Record<number, string> {
  const m: Record<number, string> = {}
  for (const [id, key] of Object.entries(RISK_TYPE_I18N_KEYS)) {
    m[Number(id)] = t(key)
  }
  return m
}

/**
 * 筛选用：相同展示文案的多个 id 合并为 `[id1,id2]` → 文案（与历史 mergeMap(RiskTypeLabel) 行为一致）。
 */
function riskTypeSearchLabels (t: ComposerTranslation): Record<string, string> {
  return mergeMap(riskTypeLabels(t))
}

export { riskTypeLabels, riskTypeSearchLabels }
